import { render, staticRenderFns } from "./WindowResize.vue?vue&type=template&id=3847d172"
import script from "./WindowResize.vue?vue&type=script&lang=js"
export * from "./WindowResize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3847d172')) {
      api.createRecord('3847d172', component.options)
    } else {
      api.reload('3847d172', component.options)
    }
    module.hot.accept("./WindowResize.vue?vue&type=template&id=3847d172", function () {
      api.rerender('3847d172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/main/components/WindowResize.vue"
export default component.exports